import styled from 'styled-components';

export const PageWrapper = styled.main`
  background: #f4f7f9;
  min-height: calc(100vh - 80px);
`;
